module.exports = __webpack_public_path__ + "img/mark-price.9956c501.jpg";